import React, { useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from '@material-ui/core/CircularProgress';
import CardBody from "beaktShared/components/Card/CardBody.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Close from "@material-ui/icons/Close";
import Check from "@material-ui/icons/Check";
import CheckCircle from "@material-ui/icons/CheckCircle";
import RemoveCircleOutline from "@material-ui/icons/RemoveCircleOutline";
import Warning from "@material-ui/icons/Warning";
import "beaktShared/components/CustomInput/rotate.css";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import {UseGetApiSimple, UsePutApi } from "beaktShared/services/crudeApiService";
import Badge from "beaktShared/components/Badge/Badge.js";
import { SessionContext, getSessionCookie } from "beaktShared/services/session";
import { formateDate } from "beaktShared/helpers/masks";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function VisualizarAgendamento({ prof, serv, selectedEvent, closemodalEdit, seteditevent }) {
  const { t } = useTranslation();
  const [session, setSession] = React.useState(useContext(SessionContext));
  const classes = useStyles();
  const { register, handleSubmit } = useForm({ mode: "onChange" });

  const [loading, setLoading] = React.useState(false);
  const [notification, setNotification] = React.useState(false);
  const [colorNotification, setColorNotification] = React.useState('info');
  const [mensagemNotification, setMensagemNotification] = React.useState(false);
  const showNotification = (mensagem, color) => {
    setMensagemNotification(mensagem);
    setColorNotification(color);
    setNotification(true);
    setTimeout(function () {
      setNotification(false);
    }, 6000);
  };

  var dadosIni = {
    id: 0,
    data: '',
    hora: '',
    horafim: '',
    title: '',
    status: 0,
  }
  const [dados, setdados] = React.useState(dadosIni);

  useEffect(() => {

    setshowModalOBS(false);

    setSession(getSessionCookie());

    if (!selectedEvent.start)
      return;

    var dateComplete = new Date(selectedEvent.start);
    var dateCompleteend = new Date(selectedEvent.end);

    var hours = dateComplete.getHours();
    var minutes = dateComplete.getMinutes();
    if (hours <= 9)
      hours = "0" + hours;
    if (minutes <= 9)
      minutes = "0" + minutes;

    var hoursend = dateCompleteend.getHours();
    var minutesend = dateCompleteend.getMinutes();
    if (hoursend <= 9)
      hoursend = "0" + hoursend;
    if (minutesend <= 9)
      minutesend = "0" + minutesend;

    var time = hours + ":" + minutes;
    var timeend = hoursend + ":" + minutesend;

    creatBStatus(selectedEvent.statusAgendamento);

    var dados = {
      data: formateDate(dateComplete),
      hora: time,
      horafim: timeend,
      ...selectedEvent
    }
    setdados(dados);

    //console.log(dados)

  }, [selectedEvent]);

  const [statusShow, setStatusShow] = React.useState('');

  const creatBStatus = (statusAgendamento) => {

    var ss = "";
    if (statusAgendamento === 0)
      ss = (<Badge color="info">{t('agenda.pending')}</Badge>)
    else if (statusAgendamento === 1)
      ss = (<Badge color="success">{t('agenda.confirmed')}</Badge>)
    else if (statusAgendamento === 2)
      ss = (<Badge color="danger">{t('agenda.canceled')}</Badge>)
    else if (statusAgendamento === 3)
      ss = (<Badge color="default">{t('agenda.removed')}</Badge>)
    else if (statusAgendamento === 4)
      ss = (<Badge color="warning">{t('agenda.missed')}</Badge>)
    else if (statusAgendamento === 5)
      ss = (<Badge color="primary">{t('agenda.showed_up')}</Badge>)

    setStatusShow(ss);
  }

  const hideModal = () => {
    closemodalEdit();
    setshowModalOBS(false);
  }

  const [showModalOBS, setshowModalOBS] = React.useState(false);
  const [Status, setStatus] = React.useState(0);
  const handleStatus = (e, status) => {
    e.preventDefault();

    if (status == 4 || status == 5) {
      setStatus(status)
      setshowModalOBS(true);
      return;
    }
    else {
      setshowModalOBS(false);
      EditarStatusAgendamento(status, " ");
    }
  };

  const onSubmit = (data, e) => {  

    EditarStatusAgendamento(Status, data.ObsAcao);
  }


  const EditarStatusAgendamento = (status, ObservacaoAcao) => {

    var agendamentostatus = 
    {
      status: status,
      userId: session.id,
      obsAcao: ObservacaoAcao
    };
    
    let endPoint = 'agendamentos/alterStatus/';

    setLoading(true);

    UsePutApi(endPoint,dados.id, agendamentostatus).then(result => {
      if (result.status !== 200) {
        showNotification(result.message, 'danger');
        setLoading(false);
        return false;
      }

      if (!(status === 3))
        creatBStatus(status);

      setLoading(false);
      seteditevent({ id: dados.id, statusAgendamento: status });
      setshowModalOBS(false);
      closemodalEdit();
      return true;
    });

  };

  return (
    <CardBody>

      <Snackbar
        place="tr"
        color={colorNotification}
        message={mensagemNotification}
        open={notification}
        closeNotification={() => setNotification(false)}
        close
      />

      {loading &&
        <div className="carregandoCmp">
          <div className="box">
            <label>{t('label.loading')}...</label>
            <CircularProgress />
          </div>
        </div>
      }

      <form onSubmit={handleSubmit(onSubmit)}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <h5 style={{ paddingRight: '60px', }}>
              {t('agenda.scheduling')} <b>{dados.data}</b> <br />{t('label.at')} <b>{dados.hora}</b> </h5>
            <Button
              onClick={hideModal}
              justIcon
              color="transparent"
              style={{
                position: 'absolute',
                right: '10px',
                top: '10px',
                color: 'red'
              }}
            >
              <Close className={classes.icons} />
            </Button>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <input className={classes.hidden} name="idcliente" ref={register} />
            <br /><b>{t('label.period')}:</b> {dados.hora} - {dados.horafim}
            <br /><b>{t('label.client')}:</b> {dados.nomeCliente}
            <br /><b>{t('label.cell_phone')}:</b> {dados.celularcliente}
            <br /><b>{t('label.professional')}:</b> {dados.nomeProfissional}
            <br /><b>{t('label.service')}:</b> {dados.descricaoServico}
            <br /><b>{t('label.obs')}:</b> {dados.obs}
            <br /><b>{t('label.status')}:</b> {statusShow} {selectedEvent.observacaoAcao == null ? "" : "/" + selectedEvent.observacaoAcao}
            <br />
            <br />
            <div style={{ textAlign: 'center' }} >

              <>
                <Button onClick={e => handleStatus(e, 2)} color="danger" style={{ justifyContent: 'left', minWidth: '210px' }} >
                  <Close /> {t('button.cancel')}
                </Button>
                <br />
                <Button onClick={e => handleStatus(e, 1)} color="success" style={{ justifyContent: 'left', minWidth: '210px' }} >
                  <Check className={classes.icons} />  {t('label.confirm')}
                </Button>
                <br />
              </>
              <>
                <Button onClick={e => handleStatus(e, 5)} color="primary" style={{ justifyContent: 'left', minWidth: '210px' }} >
                  <CheckCircle className={classes.icons} />  {t('label.client')} {t('agenda.showed_up')}
                </Button>
                <br />
                <Button onClick={e => handleStatus(e, 4)} color="warning" style={{ justifyContent: 'left', minWidth: '210px' }}>
                  <Warning className={classes.icons} />   {t('label.client')} {t('agenda.missed')}
                </Button>
              </>

              <br />
              <Button onClick={e => handleStatus(e, 3)} style={{ justifyContent: 'left', minWidth: '210px' }} >
                <RemoveCircleOutline className={classes.icons} />  {t('button.remove')}
              </Button>
            </div>
          </GridItem>
        </GridContainer>
        <br></br>
        {
        showModalOBS &&
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl fullWidth className={classes.formControl}>
              <TextField
                label={t('label.obs_action')}
                variant="outlined"
                inputRef={register}
                name="ObsAcao"
                defaultValue={""}
                InputLabelProps={{ shrink: true }}
                multiline
                rowsMax="3"
                rows="2"
                inputProps={{ maxLength: 500 }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'center' }}>
            <Button round type="submit" color="primary">
              {t('button.to_save')}
            </Button>
          </GridItem>
        </GridContainer>
      }
      </form>
    </CardBody>
  );
}
